import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { sgrColors } from '../../../ui/sgr/SgrColors';

interface FilterFieldBoxProps {
  label: ReactNode;
  /** Small icon rendered before the label */
  icon?: ReactNode;
  /** Optional element aligned to the right of the label, e.g. a clear button */
  action?: ReactNode;
  children: ReactNode;
}

const FilterFieldBox = ({ label, icon, action, children }: FilterFieldBoxProps) => {
  return (
    <Box
      sx={{
        border: `1px solid ${sgrColors.grey_cloud}`,
        borderRadius: '0.5rem',
        padding: '0.625rem 0.875rem',
        backgroundColor: '#ffffff',
        transition: 'border-color 120ms ease-in-out',
        '&:hover': { borderColor: sgrColors.steel },
        '&:focus-within': { borderColor: sgrColors.azure },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.375rem',
          marginBottom: '0.25rem',
          color: sgrColors.backdrop,
        }}
      >
        {icon}
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            color: sgrColors.backdrop,
          }}
        >
          {label}
        </Typography>
        {action && <Box sx={{ marginLeft: 'auto' }}>{action}</Box>}
      </Box>
      {children}
    </Box>
  );
};

export default FilterFieldBox;
